import { render, staticRenderFns } from "./pretopup-add-or-update.vue?vue&type=template&id=84b94388&scoped=true&"
import script from "./pretopup-add-or-update.vue?vue&type=script&lang=js&"
export * from "./pretopup-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./pretopup-add-or-update.vue?vue&type=style&index=0&id=84b94388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b94388",
  null
  
)

export default component.exports